import React from "react";
import { formatCurrency } from "../utils/formatCurrency";

const EMPTY = "$\u2014";
const GREY = "var(--od-c-6c757d, #6c757d)";

const SummaryCard = ({ expected, hasInputs }) => {
  const profitColor = hasInputs
    ? expected.hitsCM
      ? "#28a745"
      : expected.showProfit > 0
      ? "#ffc107"
      : "#FF595E"
    : GREY;

  const profitLabel = hasInputs
    ? expected.hitsCM
      ? "Hits CM Target"
      : expected.showProfit > 0
      ? "Profitable, Below CM"
      : "Unprofitable"
    : null;

  const cardStyle = (bg) => ({
    borderRadius: 8,
    border: "1px solid var(--od-c-e9eaeb, #e9eaeb)",
    backgroundColor: bg || "var(--od-c-ffffff, #fff)",
    marginBottom: 0,
    height: "100%",
  });

  const bodyStyle = { padding: "10px 12px" };
  const valueStyle = { fontSize: "1.2rem", fontWeight: 700, color: hasInputs ? undefined : "var(--od-c-717680, #d0d5dd)" };

  return (
    <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
      <div style={{ flex: 1 }}>
        <div className="card" style={cardStyle()}>
          <div style={bodyStyle}>
            <div className="small text-muted" style={{ marginBottom: 2 }}>Total Revenue</div>
            <div style={valueStyle}>
              {hasInputs ? formatCurrency(expected.totalRevenue) : EMPTY}
            </div>
          </div>
        </div>
      </div>
      <div style={{ flex: 1 }}>
        <div className="card" style={cardStyle()}>
          <div style={bodyStyle}>
            <div className="small text-muted" style={{ marginBottom: 2 }}>Artist Payout</div>
            <div style={valueStyle}>
              {hasInputs ? formatCurrency(expected.artistPayout) : EMPTY}
            </div>
          </div>
        </div>
      </div>
      <div style={{ flex: 1 }}>
        <div className="card" style={cardStyle()}>
          <div style={bodyStyle}>
            <div className="small text-muted" style={{ marginBottom: 2 }}>Show Profit</div>
            <div style={{ ...valueStyle, ...(hasInputs && { color: profitColor }) }}>
              {hasInputs ? formatCurrency(expected.showProfit) : EMPTY}
            </div>
          </div>
        </div>
      </div>
      <div style={{ flex: 1 }}>
        <div
          className="card"
          style={cardStyle(
            hasInputs
              ? expected.hitsCM ? "var(--sl-bg-success-primary)" : expected.showProfit > 0 ? "var(--sl-bg-warning-primary)" : "var(--sl-bg-error-primary)"
              : undefined
          )}
        >
          <div style={bodyStyle}>
            <div className="small text-muted" style={{ marginBottom: 2 }}>vs. CM Target</div>
            <div style={{ ...valueStyle, ...(hasInputs && { color: profitColor }) }}>
              {hasInputs
                ? `${expected.cmDelta >= 0 ? "+" : ""}${formatCurrency(expected.cmDelta)}`
                : EMPTY}
            </div>
            {profitLabel && (
              <div style={{ fontSize: "0.7rem", color: profitColor, fontWeight: 600 }}>
                {profitLabel}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryCard;
